import React, { Component } from "react";
import moment from "moment";
import underscore from "underscore";
import {
  Row,
  Col,
  Button,
  Popconfirm,
  Upload,
  Icon,
  Input,
  Spin,
  Modal,
  Form,
} from "antd";
import { app, api, config } from "../../app";
import TeamSeleted from "../../components/TeamSeleted2";
// import FormModal from "../../components/FormModal2"
import BraftEditor from "braft-editor";
import { ContentUtils } from "braft-utils";

const FormItem = Form.Item;
const TextArea = Input.TextArea;

class ProTeamManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataList: [],
      verificationAddress: "",
      select_bn: {},
      edit_bn: {},
      select_team: {},
      dl_loading: false,
      submit_loading: false,
      edit_visible: false,
      has_content: 0,
    };
  }

  /**
   * 设置值
   * @param data
   */
  setData = (data) => app.setStateSync(this, data);

  async componentDidMount() {
    this._isMounted = true;
    const innerHeight = document.body.offsetHeight,
      table_height = innerHeight - (78 + 60 + 36 + 60 + 58);
    await this.setData({ table_height });
    window.addEventListener("resize", this.onWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onWindowResize);
    this._isMounted = false;
  }

  /**
   * 数据
   */
  handleDataList = async (select_team, load_index) => {
    await this.setData({ load_index, select_team, dl_loading: true });
    const params = {
      team_id: select_team.team_id,
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    };
    let { flag, data, msg } = await app.post(api.coinSiteDetails, params);
    let select_bn = {};
    if (flag !== 1) {
      data = [];
      app.alert(msg, "error");
    } else {
      select_bn = data[0] || {};
    }
    const state = {
      select_bn,
      verificationAddress: data.coin_site,
      dataList: data,
    };
    if (this.state.load_index === load_index) {
      state.dl_loading = false;
    }
    await this.setData(state);
  };

  /**
   * 编辑队伍信息
   * @param e
   */
  handleEditTeam = async () => {
    if (this.state.edit_loading) return false;
    this.setData({ edit_loading: true });
    let { dataList, verificationAddress,select_team } = this.state;
    if (!verificationAddress) {
      app.alert("核销地址不能为空！", "warning");
    }
    let values = {};
    values.indexno = app.getData("indexno");
    values.account = app.getData("account");
    values.site_id = dataList.site_id;
    values.coin_site = verificationAddress;
    values.team_id = select_team.team_id;
    let { flag, msg } = await app.post(api.coinSiteEdit, values);
    if (flag === 1) {
      app.alert("修改成功", "success");
      await app.sleep(1000);
      window.location.reload();
    } else {
      app.alert(msg, "error");
    }
    this.setData({ edit_loading: false });
  };

  render() {
    let formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 13 },
    };
    let {
      dataList,
      select_bn,
      edit_visible,
      edit_bn,
      dl_loading,
      submit_loading,
      detail_loading,
      has_content,
    } = this.state;
    return (
      <div style={{ padding: 20 }}>
        <div className="bottom-navigation">
            <div className="page-content">
              <Row className="content">
                <Col span={5} className="team-select">
                  <TeamSeleted handleData={this.handleDataList} />
                </Col>
                <Col span={17} offset={1} className="team-table" style={{marginTop:'50px'}}>
                <Form style={{ width: "100%" }}>
                  <FormItem label="核销地址" {...formItemLayout}>
                    <TextArea
                      placeholder="请输入核销地址"
                      autoSize={{ maxRows: 8, minRows: 3 }}
                      value={this.state.verificationAddress}
                      onChange={(e) =>
                        this.setState({ verificationAddress: e.target.value })
                      }
                    />
                  </FormItem>
                  <p
                    span={6}
                    style={{
                      color: "red",
                      margin: "0 auto",
                      textAlign: "center",
                    }}
                  >
                    注：核销地址是爱心商品兑换的具体地址，设置后在商品详情可查看
                  </p>
                  <FormItem wrapperCol={{ span: 12, offset: 6 }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ margin: "0 20px" }}
                      loading={submit_loading}
                      onClick={this.handleEditTeam}
                    >
                      修改
                    </Button>
                  </FormItem>
                </Form>
              </Col>
              </Row>
        
            </div>
          
        </div>
      </div>
    );
  }
}

export default Form.create()(ProTeamManage);



// WEBPACK FOOTER //
// ./src/routes/grade/site.jsx